import { render, staticRenderFns } from "./userAccount.vue?vue&type=template&id=06710180&scoped=true&"
import script from "./userAccount.vue?vue&type=script&lang=js&"
export * from "./userAccount.vue?vue&type=script&lang=js&"
import style0 from "./userAccount.vue?vue&type=style&index=0&id=06710180&scoped=true&lang=css&"
import style1 from "./userAccount.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06710180",
  null
  
)

export default component.exports